import script from "./MissionsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MissionsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MissionsSidebar.vue?vue&type=style&index=0&id=6da00bd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da00bd6"]])

export default __exports__